/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminService } from './services/admin.service';
import { AttorneyService } from './services/attorney.service';
import { CaseService } from './services/case.service';
import { ClientRepService } from './services/client-rep.service';
import { PingService } from './services/ping.service';
import { ReportService } from './services/report.service';
import { SurveyService } from './services/survey.service';
import { SurveyContactService } from './services/survey-contact.service';
import { SurveyContactHistoryService } from './services/survey-contact-history.service';
import { SurveyContactTypeService } from './services/survey-contact-type.service';
import { SurveyMethodService } from './services/survey-method.service';
import { SurveyQuestionService } from './services/survey-question.service';
import { SurveyResponseService } from './services/survey-response.service';
import { SurveyTypeService } from './services/survey-type.service';
import { SurveyVersionService } from './services/survey-version.service';
import { ValidationTokenService } from './services/validation-token.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminService,
    AttorneyService,
    CaseService,
    ClientRepService,
    PingService,
    ReportService,
    SurveyService,
    SurveyContactService,
    SurveyContactHistoryService,
    SurveyContactTypeService,
    SurveyMethodService,
    SurveyQuestionService,
    SurveyResponseService,
    SurveyTypeService,
    SurveyVersionService,
    ValidationTokenService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
